export class AvaiableConditions {
  public weather: any = {
    city: 'Loading...',
    data: {
      currentDayForecast: {},
      currentConditions: {
        tempF: '-',
        tempC: 'c',
        humidity: '0%',
        windGustMPH: 0,
        windDir: 'NW',
        feelslikeF: '0',
        feelslikeC: '0',
        windSpeedMPH: '',
        pressureIN: '0',
        place: {
          name: '',
          state: '',
        },
        ob: {
          weatherPrimary: '',
        }
      },
      forecast10Day: {
          forecastday: []
      }

    }
  };

  public dummyForecast = {
    icon: '',
    conditions: '',
    weekday: '',
    weekday_short: '',
    maxTempF: '0',
    maxTempC: '0',
    minTempF: '0',
    minTempC: '0'
  };

  public data = [
    {
      targetName: 'Player',
      target: 'currentPlayer',
      typeList: [
        {
          typeName: 'Weather',
          fieldList: [
            {
              fieldName: 'Current Temp',
              path: 'weather.data.currentConditions.ob.tempF',
              valueType: 'number',
              valueLabel: '°F',
              valueSize: 4
            },
            {
              fieldName: 'Current Feels',
              path: 'weather.data.currentConditions.ob.feelslikeF',
              valueType: 'number',
              valueLabel: '°F',
              valueSize: 4
            },
            {
              fieldName: 'Conditions Text',
              path: 'weather.data.currentDayForecast.weatherPrimary',
              valueType: 'number',
              valueLabel: '',
              valueSize: 10
            },
            {
              fieldName: 'Daily High',
              path: 'weather.data.currentDayForecast.maxTempF',
              valueType: 'number',
              valueLabel: '°F',
              valueSize: 4
            },
            {
              fieldName: 'Daily Low',
              path: 'weather.data.currentDayForecast.minTempF',
              valueType: 'number',
              valueLabel: '°F',
              valueSize: 4
            },
            {
              fieldName: 'Bar Pressure',
              path: 'weather.data.currentConditions.ob.pressureIN',
              valueType: 'number',
              valueLabel: 'in',
              valueSize: 4
            },
            {
              fieldName: 'Wind Speed',
              path: 'weather.data.currentConditions.ob.windSpeedMPH',
              valueType: 'number',
              valueLabel: 'MPH',
              valueSize: 4
            },
            {
              fieldName: 'Wind Direction',
              path: 'weather.data.currentConditions.ob.windDir',
              valueType: 'number',
              valueLabel: 'eg NW',
              valueSize: 3
            },
            {
              fieldName: 'Humidity',
              path: 'weather.data.currentConditions.ob.humidity',
              valueType: 'number',
              valueLabel: '%',
              valueSize: 4
            }
          ]
        },
        {
          typeName: 'Screen Stats',
          fieldList: [
            {
              fieldName: 'Total Plays',
              path: 'weather.data.high',
              valueType: 'number',
              valueLabel: '',
              valueSize: 4
            },
            {
              fieldName: 'Total Screen Time',
              path: 'weather.data.high',
              valueType: 'number',
              valueLabel: 'minutes',
              valueSize: 4
            }
          ]
        }

      ]
    }
  ];

  public operations = [
    {
      label: 'Equals',
      value: 'eq',
      valueType: ['number', 'string']
    },
    {
      label: 'NOT Equal',
      value: 'ne',
      valueType: ['number', 'string']
    },
    {
      label: 'Greater Than',
      value: 'gt',
      valueType: ['number']
    },
    {
      label: 'Less Than',
      value: 'lt',
      valueType: ['number']
    },
    {
      label: 'Contains',
      value: 'contains',
      valueType: ['string']
    }

  ];
}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/scheduling/components/editconditions-dialog/avaiable-conditions.ts